import { fromJS } from 'immutable';
import { AnyAction } from 'redux';

import type { TypedMap } from 'utils/typed-map';

import { INIT, INIT_SUCCESS, INIT_FAILED } from './constants';

export type CreateEmployeeFormPageState = TypedMap<{ loading: boolean }>;

export const initialState: CreateEmployeeFormPageState = fromJS({
  loading: false,
});

const CreateEmployeeFormPageReducer = (
  state: CreateEmployeeFormPageState = initialState,
  action: AnyAction
): CreateEmployeeFormPageState => {
  switch (action.type) {
    case INIT:
      return state.set('loading', true);

    case INIT_SUCCESS:
      return state.merge({ loading: false });

    case INIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    default:
      return state;
  }
};

export default CreateEmployeeFormPageReducer;
